var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCarrousel = function SvgCarrousel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4202 15.7564C27.4202 18.0968 27.4202 20.4385 27.4202 22.7816C27.4248 23.3896 27.3082 23.9925 27.0772 24.5551C26.8462 25.1176 26.5054 25.6286 26.0747 26.0583C25.6439 26.4879 25.1319 26.8277 24.5684 27.0577C24.0048 27.2877 23.4011 27.4033 22.7924 27.3979C18.0885 27.4047 13.3847 27.4047 8.68077 27.3979C6.0509 27.3979 4.01937 25.3942 4.01121 22.7704C3.99626 18.0394 3.99626 13.3074 4.01121 8.57433C4.01937 6.02895 5.99993 4.0293 8.52787 4.01912C13.2997 4.00079 18.0712 4.00079 22.8424 4.01912C25.4172 4.03032 27.4028 6.05542 27.4161 8.63643C27.4263 11.0067 27.4202 13.382 27.4202 15.7564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0977 30.3967H10.7368C16.1053 30.4015 21.4737 30.4055 26.8422 30.4089C27.1647 30.4144 27.4873 30.4025 27.8085 30.3733C29.3946 30.2012 30.418 29.0986 30.4904 27.4298C30.5383 26.3292 30.52 25.2245 30.521 24.1218C30.521 19.6936 30.521 15.2653 30.521 10.837V10.2312C30.8064 10.3717 31.0306 10.445 31.207 10.5753C32.3028 11.3685 32.9704 12.4345 32.9776 13.7957C33.001 18.801 33.0112 23.8062 32.9715 28.8104C32.9531 31.1288 31.1611 32.883 28.8391 32.9115C24.0329 32.9655 19.2258 32.9869 14.4196 33.0001C12.646 33.0052 11.2281 32.2986 10.2873 30.751C10.2363 30.6696 10.1996 30.5749 10.0977 30.3967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarrousel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carrousel.d7aaaec6.svg";
export { ForwardRef as ReactComponent };